var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property } from '@syncfusion/ej2-base';
/**
 * customize the size of the individual palette items.
 */
export class SymbolSize extends ChildProperty {
}
__decorate([
    Property()
], SymbolSize.prototype, "width", void 0);
__decorate([
    Property()
], SymbolSize.prototype, "height", void 0);
/**
 * Defines the size and description of a symbol
 */
export class SymbolPaletteInfo extends ChildProperty {
}
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "width", void 0);
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "height", void 0);
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "fit", void 0);
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "description", void 0);
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "template", void 0);
__decorate([
    Property()
], SymbolPaletteInfo.prototype, "tooltip", void 0);
